import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type UpdateAccountFinanceIdMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountFinanceIdInput;
}>;

export type UpdateAccountFinanceIdMutationResult = { __typename?: 'Mutation' } & {
  updateAccountFinanceId: { __typename?: 'UpdateAccountFinanceIdPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateAccountFinanceIdDocument = gql`
  mutation updateAccountFinanceId($input: UpdateAccountFinanceIdInput!) {
    updateAccountFinanceId(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
